import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Switch } from '../../../../../../shared/types/modules/switch';

export const useSwitchRegisterHistory = (switchDetail?: Switch) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = switchDetail || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [switchDetail]);

    return {
        formik,
    };
};
